import { render, staticRenderFns } from "./ImagenInfografica.vue?vue&type=template&id=1b097012&lang=pug&"
import script from "./ImagenInfografica.vue?vue&type=script&lang=js&"
export * from "./ImagenInfografica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports